import { Component, OnInit, ViewChild } from '@angular/core';
import { DxMenuComponent } from 'devextreme-angular';
import * as shajs from 'sha.js'
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';
import { environment as env } from '../../environments/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'orchestra-top-bar',
  templateUrl: './orchestra-top-bar.component.html',
  styleUrls: ['./orchestra-top-bar.component.scss']
})
export class OrchestraTopBarComponent implements OnInit {
  passwordData: any = {};
  dlgChangePasswordVisible:boolean = false;
  title = 'ORCHESTRA ';
  versi = env["version"];
  styleorchestra = "font-size:20px; font-family: Inter-SemiBold";
  styleversi = "font-size:15px; font-family: Inter; padding-top:2.7px";
  appItem:any[] = [];
  menuItems:any[] = [
    {
      text: 'User', icon: 'fa fa-fw fa-address-book',
      items: [
        {
          selectable: false,
          disabled: false,
          template: 'template for current user'
        },
        { text: 'Change Password', icon: 'fa fa-fw fa-key' },
        { text: 'Logout', icon: 'fa fa-fw fa-sign-out' }
      ]
    }
  ];
  @ViewChild("appMenu") menu:DxMenuComponent;

  constructor(public auth: AuthService, public global: GlobalService) {
  }

  ngOnInit() {
    // this.global.blockUI = true;
    if (this.auth.user != null) {
      //Update current app & menus

      //Show current user on the menu
      this.menuItems[0].items[0].template = `<div class='dx-theme-accent-as-background-color first-item'>
    ${this.auth.user.fullName}
    </div>`;
    }
    // this.global.blockUI = false;
  }

  onMenuClick(data) {
    let idx = this.appItem.findIndex(x=>x.text==data.itemData.text);
    if (idx>=0){
      if (this.auth.getCookie('token') != undefined) {
        let url = this.appItem[idx].url;
        if (this.appItem[idx].url != null) {
          window.location.replace(url+"/");
        }
      }else{
        this.logout();
      }
    }else{
      if (data.itemData.text == 'Change Password') {
        this.dlgChangePasswordVisible = true;
      }
      else if (data.itemData.text == 'Logout') {
        this.logout();
      }
    }
  }

  logout() {
    this.auth.logout();
  }

  toggleSidebar() {
    this.auth.isSidebarOpened = !this.auth.isSidebarOpened;
  }

  changePassword(args) {
    if (!args.validationGroup.validate().isValid) {
      return;
    }

    if (this.passwordData.new != this.passwordData.confirm) {
      this.global.showErrorDialog("Konfirmasi password salah.");
    } else {
      this.global.get(`msuser/detail/` + this.auth.user.userName)
        .then(detail => {
          this.auth.user.password = shajs('sha256').update(this.passwordData.old).digest('hex');
          this.auth.user.newPassword = shajs('sha256').update(this.passwordData.new).digest('hex');
          this.global.post(`msuser/edit`, this.auth.user)
            .then(result => {
              this.passwordData = {};
              this.global.showSuccessDialog("Password berhasil diubah.");
              localStorage.setItem('auth.changepassword', 'NO');
              this.dlgChangePasswordVisible = false;
            });
        });
    }
  }
}
